import React, { useState } from 'react';
import Select from "../../../Component/Select";
import { addDays, formatDate } from "../../../Utis/GlobalFunctions";
import axios from "axios";
import Swal from 'sweetalert2';
import CircularLoader from "../../../Component/CircularLoader";

const NjvSchool = () => {
    const [currentDate] = useState(new Date())
    const newDate = addDays(currentDate, 3);
    const [loading,setLoading] = useState(false)
    const [credentials,setCredentails] = useState({
        username: "NJV_School",
        password: "Live@ns25",
        clientId: "EGbINIeAAdPmLEy",
        clientSecret: "fpPSnxuxpDfpl1l"

        //ORANTECH
        // username: "Oraan_tech",
        // password: "P@ssw0rd",
        // clientId: "QjJLPSgmte17rXA",
        // clientSecret: "uM8AjQfPPde7BxL"
    });
    // State to handle form input values
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phoneNumber: '',

        amount: '',
        address: '',
        currency: '',
        donationType: '',
        comments:"",
    });

    // State to handle errors
    const [errors, setErrors] = useState({});


    let payload
    if(formData.currency === "PKR") {
        payload = [
            {
                MerchantId: credentials?.username
            },
            {
                OrderNumber: `${+currentDate}`,
                OrderAmount: formData?.amount,
                OrderDueDate: formatDate(newDate),
                OrderType: "Service",
                IssueDate: formatDate(currentDate),
                OrderExpireAfterSeconds: "0",
                CustomerName: formData?.name,
                CustomerMobile: formData?.phoneNumber??"",
                CustomerEmail: formData?.email,
                CustomerAddress: formData?.address,
                BillDetail01: [
                    {
                        internationalNumber: formData?.currency === "USD" || formData?.currency === "AED"   ? formData?.phoneNumber : "",
                        comments:formData?.comments,
                        purposeOfDonation:formData?.donationType
                    }
                ]
            }
        ];
    }else {
        payload = [
            {
                MerchantId: credentials?.username
            },
            {
                OrderNumber: `${+currentDate}`,
                CurrencyAmount: formData?.amount,
                OrderDueDate: formatDate(newDate),
                OrderType: "Service",
                IssueDate: formatDate(currentDate),
                OrderExpireAfterSeconds: "0",
                CustomerName: formData?.name,
                CustomerMobile: formData?.currency === "PKR" ? formData?.phoneNumber : "",
                CustomerEmail: formData?.email,
                CustomerAddress: formData?.address,
                Currency: formData?.currency,
                IsConverted  : "true",
                BillDetail01: [
                    {
                        internationalNumber: formData?.currency === "USD" || formData?.currency === "AED"  ? formData?.phoneNumber : "",
                        comments:formData?.comments,
                        purposeOfDonation:formData?.donationType
                    }
                ]
            }
        ];
    }


    const donationTypeData = [
        { id: 1, name: "Student's Tuition Fee", value: "StudentTuitionFee" },
        { id: 2, name: "Student's Mess Support", value: "StudentMessSupport" },
        { id: 3, name: "Student's Hostel Facility", value: "StudentHostelFacility" },
        { id: 4, name: "Student's Medical Aid", value: "StudentMedicalAid" },
        { id: 5, name: "Alumni's University Support", value: "AlumniUniversitySupport" },
        { id: 6, name: "Student's Sports Support", value: "StudentSportsSupport" },
        { id: 7, name: "Zakat - Almsgiving", value: "ZakatAlmsgiving" },
        { id: 8, name: "E-learning Schools", value: "e-learningSchools" },

    ];

    const currencyData = [
        { id: 1, name: "PKR", value: "PKR" },
        { id: 2, name: "USD", value: "USD" },
        { id: 3, name: "AED", value: "AED" }
    ];

    // Handle input changes and update form data
    // Handle input changes and update form data with real-time validation
    const handleChange = (e) => {
        const { name, value } = e.target;

        // Update the form data state
        setFormData({
            ...formData,
            [name]: value,
        });

        // Validate the specific field on change
        validateField(name, value);
    };

// Real-time field validation
    const validateField = (name, value) => {
        let fieldError = {};

        switch (name) {
            case "name":
                if (!value) {
                    fieldError.name = "Name is required.";
                } else {
                    fieldError.name = ""; // Clear error if input is valid
                }
                break;
            case "email":
                if (!value) {
                    fieldError.email = "Email is required.";
                } else if (!/\S+@\S+\.\S+/.test(value)) {
                    fieldError.email = "Email address is invalid.";
                } else {
                    fieldError.email = ""; // Clear error if input is valid
                }
                break;
            case "phoneNumber":
                if (!value) {
                    fieldError.phoneNumber = "Phone number is required.";
                } else {
                    fieldError.phoneNumber = ""; // Clear error if input is valid
                }
                break;
            case "amount":
                if (!value) {
                    fieldError.amount = "Amount is required.";
                } else {
                    fieldError.amount = ""; // Clear error if input is valid
                }
                break;
            // case "address":
            //     if (!value) {
            //         fieldError.address = "Address is required.";
            //     } else {
            //         fieldError.address = ""; // Clear error if input is valid
            //     }
            //     break;
            case "currency":
                if (!value) {
                    fieldError.currency = "Currency is required.";
                } else {
                    fieldError.currency = ""; // Clear error if input is valid
                }
                break;
            case "donationType":
                if (!value) {
                    fieldError.donationType = "Donation type is required.";
                } else {
                    fieldError.donationType = ""; // Clear error if input is valid
                }
                break;
            default:
                break;
        }

        // Update errors state
        setErrors((prevErrors) => ({
            ...prevErrors,
            ...fieldError,
        }));
    };



    // Validate form inputs
    const validateForm = () => {
        const newErrors = {};

        // Check if the name field is empty
        if (!formData.name) newErrors.name = "Name is required.";

        // Check if the email is empty or not valid
        if (!formData.email) {
            newErrors.email = "Email is required.";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Email address is invalid.";
        }

        // Check if the phone number field is empty
        if (!formData.phoneNumber) newErrors.phoneNumber = "WhatsApp Number is required.";

        // Check if the amount field is empty
        if (!formData.amount) newErrors.amount = "Amount is required.";

        // Check if the address field is empty
        // if (!formData.address) newErrors.address = "Address is required.";

        // Check if the currency is selected
        if (!formData.currency) newErrors.currency = "Currency is required.";

        // Check if donation type is selected
        if (!formData.donationType) newErrors.donationType = "Donation type is required.";

        // Update the error state
        setErrors(newErrors);

        // Return whether the form is valid or not
        return Object.keys(newErrors).length === 0;
    };

    const getAuthToken = async (clientId, clientSecret) => {
        const tokenResponse = await axios.post(`${process.env.REACT_APP_PAYPRO_LIVEAPI}/auth`, {
            clientid: clientId,
            clientsecret: clientSecret,
        });
        return tokenResponse.data.token;
    };

    const payproCreateOrder = async (e) => {
        e.preventDefault();



        // Validate the form before submission
        const isValid = validateForm();
        if (!isValid) {
            // If the form has errors, prevent submission
            return;
        }

        try {
            setLoading(true);
            const token = await getAuthToken(credentials.clientId, credentials.clientSecret);
            const headers = { 'token': token, 'Content-Type': 'application/json' };
            const url = `${process.env.REACT_APP_PAYPRO_LIVEAPI}/create-order`;
            const response = await axios.post(url, payload, { headers });

            if(response.data?.data[0].Status === "03") {
                console.log(response.data.data[1].Description)
                await Swal.fire({
                    icon: "error",
                    title: response?.data?.data[1]?.Description,
                    showConfirmButton: false,
                    timer: 1500
                });
                setLoading(false)
            }else {
                const marketplaceUrl = response.data?.data[1]?.Click2Pay
                await Swal.fire({
                    icon: "success",
                    title: "Redirecting to Marketplace",
                    showConfirmButton: false,
                    timer: 1500
                });
                setLoading(false)
                window.top.location.href = marketplaceUrl+"&callback_url=https://njv.edu.pk/thankyou/";
                // window.top.location.href = marketplaceUrl;
            }

            // return response.data;


        } catch (error) {
            console.error('Error creating order:', error);
            setLoading(false)
        }

    }


    return (
        <div className="w-11/12 lg:w-2/4 md:w-4/5 bg-white border-4 rounded-lg shadow relative m-auto">
            <form className="p-6 space-y-6" onSubmit={payproCreateOrder}>
                <div className="grid grid-cols-6 gap-6">
                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Name / Organization <span>*</span></label>
                        <input
                            type="text"
                            name="name"
                            value={formData?.name}
                            onChange={handleChange}
                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="Name / Organization"
                        />
                        {errors.name && <p className="text-red-600 text-sm">{errors.name}</p>}
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Email <span>*</span></label>
                        <input
                            type="email"
                            name="email"
                            value={formData?.email}
                            onChange={handleChange}
                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="Your Email Address"
                        />
                        {errors.email && <p className="text-red-600 text-sm">{errors.email}</p>}
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">WhatsApp Number <span>*</span></label>
                        <input
                            type="tel"
                            name="phoneNumber"
                            value={formData?.phoneNumber}
                            onChange={handleChange}
                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="Phone Number"
                        />
                        {errors.phoneNumber && <p className="text-red-600 text-sm">{errors.phoneNumber}</p>}
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Address </label>
                        <input
                            type="text"
                            name="address"
                            value={formData?.address}
                            onChange={handleChange}
                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="Address"
                        />
                        {errors.address && <p className="text-red-600 text-sm">{errors.address}</p>}
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Amount <span>*</span></label>
                        <input
                            type="text"
                            name="amount"
                            value={formData?.amount}
                            onChange={handleChange}
                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="Amount"
                        />
                        {errors.amount && <p className="text-red-600 text-sm">{errors.amount}</p>}
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Currency <span>*</span></label>
                        <Select
                            selectValue={formData?.currency}
                            setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                            name="currency"
                            data={currencyData}
                        />
                        {errors.currency && <p className="text-red-600 text-sm">{errors.currency}</p>}
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Donation Purpose <span>*</span></label>
                        <Select
                            selectValue={formData?.donationType}
                            setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                            name="donationType"
                            data={donationTypeData}
                        />
                        {errors.donationType && <p className="text-red-600 text-sm">{errors.donationType}</p>}
                    </div>

                    <div className="col-span-6 ">
                        <label className="text-md font-medium text-gray-900 block mb-2">Comments</label>
                        <textarea
                            name="comments"
                            rows={5}
                            style={{resize:"none"}}
                            value={formData?.comments}
                            onChange={handleChange}
                            className=" shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="Comments"
                        />
                        {errors.amount && <p className="text-red-600 text-sm">{errors.amount}</p>}
                    </div>

                </div>

                <div className="flex items-center justify-center">
                    <button
                        type="submit"
                        className="flex items-center gap-1  py-2 px-4 text-white bg-cyan-500 hover:bg-cyan-700 focus:ring-4 focus:ring-cyan-200 font-medium rounded-lg text-sm"
                    >
                        Submit {loading ? <CircularLoader/> : null}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default NjvSchool;